import React, { FC } from 'react';
import { Dialog, DialogContent, Box, Typography, Button } from '@mui/material';
import AccessTime from '@mui/icons-material/AccessTime';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '@hooks/redux-custom';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const TimedOutView: FC<Props> = ({ isOpen, onClose }) => {
  const history = useHistory();
  const customer = useAppSelector((state) => state.customer.value.selectedCustomer!);

  const customerRedirect = () => {
    onClose();
    history.push(`/customer-detail/${customer?.id}`, { completeOrderRedirect: 'success' });
  };

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <Box display="flex" alignItems="center" flexDirection="row" px={2} pt={3} justifyContent="center">
        <AccessTime color="warning" sx={{ fontSize: '40px' }} style={{ marginRight: '10px' }} />
        <Typography variant="h3">ORDER TIMEOUT</Typography>
      </Box>
      <DialogContent>
        <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
          <Typography variant="body1">Your order request is taking too long to process</Typography>
          <Button onClick={onClose} data-testid="timed-out-retry-btn">
            Retry
          </Button>
          <Button onClick={customerRedirect} data-testid="timer-out-home-page-btn">
            Home page
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
